import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import "../css/Login.css";
import backendUrl from "../Utils/backendUrl";
export default function Login() {


  axios.defaults.withCredentials = true; // only set once
  const navigate = useNavigate();
  const initialvalue = { username: "", pass: "" };
  const [formData, setFormData] = useState(initialvalue);
  const [showpass, setShowpas] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const handleTogglePass = async () => {
    // alert('click on password ');
    setShowpas(!showpass);
  };

  const handleFormValue = (e) => {
    const value =
      e.target.name === "username"
        ? e.target.value.trim()
        : e.target.value;

    setFormData({
      ...formData,
      [e.target.name]: value,
    });
  };

  const userlogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    try {
      const response = await axios.post(`${backendUrl}login`, formData, {
        withCredentials: true,
      });
      if (response.data.success) {
        const token = response.data.token;
        sessionStorage.setItem("authToken", token);
        // Optionally store user data if available
        if (response.data.user) {
          sessionStorage.setItem(
            "user",
            JSON.stringify({
              isLoggedIn: true,
              userData: response.data.user,
            })
          );
        }
        setFormData(initialvalue);
        navigate("/dashboard");
      } else {
        setErrorMessage(response.data.message || "Unable to sign in.");
      }
    } catch (error) {
      console.error("Error during login:", error);
      setErrorMessage(
        error.response?.data?.message ||
          "Unable to reach the login service. Please try again.",
      );
    }
  };

  useEffect(() => {
    document.title = "CopSuvidha/Login";
    document.body.classList.remove("opacitypage");
  }, []);

  return (
    <div className="login">
      <div className="form">
        <h2 className="text-info">COP Suvidha</h2>
        <h6 className="text-warning">Agra Police</h6>
        <form className="login-form" onSubmit={userlogin}>
          <input
            type="text"
            placeholder="username"
            name="username"
            value={formData.username}
            onChange={handleFormValue}
            required
            autoComplete="off"
          />
         
          <div className="password-input-wrapper">
            <input
              type={showpass ? "password" : "text"}
              placeholder="password"
              name="pass"
              value={formData.pass}
              onChange={handleFormValue}
              required
              autoComplete="off"
            />
            <span className="password-eye-icon" onClick={handleTogglePass}>
              {showpass ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
            </span>
          </div>

          <button type="submit">Login</button>
          {errorMessage && (
            <p className="login-error" role="alert">
              {errorMessage}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
